import Button from "elements/Button";
import { useEffect, useState } from "react";
import ProductBody from "./ProductBody";

const Menu = [
  {
    title: "All Products",
    icon: "fa-duotone fa-cubes",
  },
  {
    title: "Draft",
    icon: "fa-duotone fa-file-alt",
  },
  {
    title: "Wishlist",
    icon: "fa-solid fa-heart",
  },
  {
    title: "Sold",
    icon: "fa-duotone fa-check-circle",
  },
];

export default function Sidebar({ listProduct }) {
  const [active, setActive] = useState("All Products");
  const [product, setProduct] = useState({ isLoading: true, data: [] });

  useEffect(() => {
    if (active === "All Products") {
      if (listProduct) setProduct(listProduct.data);
    } else {
      if (listProduct)
        setProduct(
          listProduct.data.filter((item) => item.categories.name === active)
        );
    }
  }, [active, listProduct]);

  const handleFilter = (menu) => {
    setActive(menu);
  };

  return (
    <section className="section-product-seller">
      <div className="container">
        <div className="row">
          <div className="col-3">
            <div className="card">
              <h5>Menu</h5>
              <div className="list-group menu">
                {Menu &&
                  Menu.map((item, index) => {
                    return (
                      <Button
                        className={`btn list-group-item d-flex justify-content-between align-items-center
                        ${active === item.title ? "active" : ""}`}
                        type="button"
                        onClick={() => handleFilter(item.title)}
                        key={index}
                      >
                        <div>
                          <i className={`${item.icon} fa-xs me-3 `}></i>
                          {item.title}
                        </div>
                        <span className="badge bg-primary align-items-center">
                          14
                        </span>
                      </Button>
                    );
                  })}
              </div>
            </div>
          </div>
          <div className="col-9">
            <ProductBody listProduct={product} menu={active} />
          </div>
        </div>
      </div>
    </section>
  );
}
